module.exports = __webpack_public_path__ + "static/media/icon_145.4e34f899.svg";